export default __webpack_public_path__ + "static/media/theme.4374fa6f.png";